<template>
  <div class="grammar-tree">
    <el-tree
      ref="tree"
      node-key="id"
      :props="treeProps"
      :load="loadGrammarNode"
      :default-expanded-keys="[0]"
      lazy>
      <template v-slot:default="{node, data}">
        <div class="grammar-tree-node">
          <div>{{ node.label }}</div>
          <div class="operation">
            <i class="el-icon-edit" v-if="node.level>1" @click.stop="editType(node, data)"></i>
            <i class="el-icon-plus" @click.stop="addType(node, data)"></i>
            <i class="el-icon-delete" v-if="node.level>1" @click.stop="removeType(node, data)"></i>
          </div>
        </div>
      </template>
    </el-tree>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500">
      <GrammarTypeForm ref="form"></GrammarTypeForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <Sidebar :visible.sync="batchVisible" :header="dialogTitle">
      <GrammarTypeForm ref="batchform"></GrammarTypeForm>
      <div class="text-right">
        <el-button @click="batchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import GrammarTypeForm from './GrammarTypeForm'
import Sidebar from './../Sidebar'

export default {
  name: 'GrammarTypeTree',
  props: {
    dialog: Boolean
  },
  data () {
    return {
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      grammars: [],
      dialogTitle: '添加语法分类',
      dialogVisible: false,
      batchVisible: false,
      node: null
    }
  },
  components: { GrammarTypeForm, Sidebar },
  methods: {
    loadGrammarNode (node, resolve) {
      if (node.level === 0) {
        return resolve([{ id:0, name: 'root' }]);
      }
      this.$http.get(this.$urls.grammar_type_treelist, {
        params: {
          pid: node.data.id
        }
      }).then(res => {
        let data = res.data.map(n => {
          return this.initItem(n)
        })
        resolve(data)
      })
    },
    addType (node, data) {
      this.node = node
      this.dialogTitle = '添加语法分类:' + node.label
      if (this.dialog) {
        this.dialogVisible = true
        setTimeout(() => {
          this.$refs.form.reset({pid: node.data.id})
        }, 1)
      } else {
        this.batchVisible = true
        setTimeout(() => {
          this.$refs.batchform.reset({pid: node.data.id})
        }, 1)
      }
      if (!this.node.isLeaf && !this.node.expanded) {
        this.node.expand();
      }
    },
    editType (node, data) {
      this.node = node
      this.dialogVisible = true
      this.dialogTitle = '编辑语法分类'
      setTimeout(() => {
        this.$refs.form.reset({...data, pid: node.parent.data.id})
      }, 1)
    },
    removeType (node, data) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.put(this.$urls.grammar_type_update, { status: 0 }, {
          params: {id: data.id}
        }).then(() => {
          node.remove()
        })
      })
    },
    submitForm () {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        this.node.data.name = this.$refs.form.form.name
        if (this.$refs.form.form.pid) {
          //
        }
      })
    },
    handleBatch () {
      this.batchVisible = true;
    },
    submitBatch () {
      this.$refs.batchform.submit().then((res) => {
        let data = res.data.map(n => {
          return this.initItem(n)
        })
        this.node.loaded = true;
        this.node.loading = false;
        this.node.doCreateChildren(data)
        this.node.updateLeafState()
        if (!this.node.expanded) {
          this.node.expand();
        }
        this.$refs.batchform.reset({pid: this.$refs.batchform.form.pid})
      })
    },
    initItem (n) {
      return {
        id: n.id,
        name: n.name,
        root: n.root,
        lft: n.lft,
        rgt: n.rgt,
        isLeaf: n.rgt - n.lft === 1
      }
    }
  }
}
</script>

<style lang="scss">
  .grammar-tree{
    .el-tree-node__content{
      height: auto;
    }
  }
  .grammar-tree-node{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    > div:first-child{
      flex: 1;
    }
    >.operation{
      > i{
        margin-right: 8px;
        &:hover{
          color: #409EFF;
        }
      }
    }
  }
</style>
